<template>
    <PageBase title="Ambitiethema waardebehoud" description="" :valid="valid" @show-error="showError" :right-button-classes="'mr-12'" :show-right-margin="false">
      <div class="flex gap-4 xl:-mt-6 mr-12">
        <div class="flex-1"></div>
        <div class="text-base -mt-2 text-right w-64 xl:w-auto xl:mt-2">Dit ambitiethema meenemen in de aanvraag?</div>

        <JaNeeToggleButton v-model="store.registrationData.prioriteringsThemas.waardebehoud" />
      </div>
      <div class="flex flex-col gap-3 max-h-[calc(100vh-270px)] overflow-y-auto overflow-x-hidden pr-12">

        <div class="flex flex-col-reverse lg:flex-row gap-5">
            <div class="flex-1">
              <img class="object-contain" src="/src/assets/Waardebehoud.png" />
            </div>
          <div class="flex-1 flex flex-col gap-4">

      <div class="text-sm italic">Het generieke Programma van Eisen (PvE) voor schoolgebouwen
biedt een flexibel raamwerk dat eenvoudig kan worden afgestemd op
de specifieke wensen van gemeenten en schoolbesturen. Dit gebeurt
aan de hand van verschillende ambitie-opties, zoals de optie voor
waardebehoud. Deze keuze stelt opdrachtgevers in staat om te kiezen
voor een meer circulaire bouwbenadering, wat resulteert in een
gebouw met een hogere restwaarde.
      </div>

      <div class="text-sm">Waardebehoud is een cruciaal aspect in de circulaire bouweconomie
omdat het zorgt voor een duurzame toekomst door het
minimaliseren van afval en het maximaliseren van het hergebruik van
bouwproducten - en elementen en daarmee de cyclus rond maakt.
Het thema waardebehoud vertaalt zich in het Programma van Eisen
naar financiële restwaarde. Om de financiële restwaarde te kunnen
borgen gelden hierbij een aantal randvoorwaarden namelijk de
losmaakbaarheid, materiaalgebruik en materiaalgebonden CO2-
uitstoot.</div>

      <div class="text-sm">Financiële restwaarde, verwijst naar de hergebruikwaarde van een
gebouw, module, element of product. De hergebruikwaarde is de
waarde van een gebouw, module, element of product verminderd
met een set aan correctiefactoren, zoals demontagekosten en
transportkosten. Financiële restwaarde is bij de ontwikkeling van
onderwijshuisvesting van belang, omdat het invloed heeft op de
business case van het project Het uitgangspunt is namelijk dat bij
circulaire investeringen een restwaarde kan worden gehanteerd
wat resulteert in lagere kapitaalslasten. Op dit moment schrijft een
gemeente nog vaak af tot nihil bij overige activa. Door de lagere
kapitaallasten ontstaat ruimte om een hogere investering te doen
waarbij hogere circulaire ambities kunnen worden gerealiseerd.</div>

      <div class="text-sm">Losmaakbaarheid is één van de belangrijke randvoorwaarden
voor financiële restwaarde. De losmaakbaarheid van een gebouw
is de mate waarin objecten demontabel zijn op alle mogelijke
gebouwniveaus, zonder afbreuk te doen aan de functie van het
object (of omliggende objecten) om zo de bestaande waarde te
beschermen. Losmaakbaarheid is een randvoorwaarde om financiële
restwaarde mogelijk te maken: een onlosmaakbaar object kan
immers in zijn geheel worden gedemonteerd en (hoogwaardig)
worden hergebruikt.</div>

        <div class="text-sm">In het kort, waardebehoud in onderwijshuisvesting omvat zowel
financiële restwaarde, losmaakbaarheid inclusief andere essentiële
randvoorwaarden zoals materiaalgebruik en materiaalgebonden
CO2-uitstoot. Door te investeren in duurzame bouwproducten- en
materialen en demontabel te ontwerpen kunnen schoolbesturen
de waarde van hun onderwijsgebouwen behouden en tegelijkertijd
bijdragen aan een duurzamere toekomst.</div>
</div>

</div>
    </div>
  </PageBase>
</template>

<script setup lang="ts">
import PageBase from '@/views/pages/PageBase.vue'
import JaNeeToggleButton from '@/components/JaNeeToggleButton.vue';
import { useRegistrationStore } from '@/stores/registration'
import { ref } from 'vue';
const errorsShown = ref(false)
const valid = ref(true)

const store = useRegistrationStore()

function showError() {
  errorsShown.value = true
}
</script>
